import * as React from "react";

type ButtonProps = React.ComponentPropsWithoutRef<"button">;

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, type = "button", ...props }, ref) => {
    return (
      <button
        ref={ref}
        type={type}
        className={
          className ??
          "inline-flex items-center justify-center whitespace-nowrap rounded-md"
        }
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export default Button;
